import Api from "./ApiNode";

export default {
 
    getAllPortExpenseList(payload, config) {
        const queryParams = new URLSearchParams(payload).toString();
        // let AllCommonJobList = Api().get(`sline-account?${queryParams}`, payload, config);
        let AllCommonJobList = Api().post("port-exp/get", payload, config);
        return AllCommonJobList;
    },
    upsertPortExp(payload, config) {
        let AllCommonJobList = Api().post("port-exp", payload, config);
        return AllCommonJobList;
    },
    upsertExcelBulkPortExp(payload, config) {
        let AllCommonJobList = Api().post("port-exp/excel-bulk-port-exp", payload, config);
        return AllCommonJobList;
    },

    clearPortExpense(payload, config) {
        let AllCommonJobList = Api().post("port-exp/clear-expense", payload, config);
        return AllCommonJobList;
    },

    pdfReaderToJson(payload, config) {
        let AllCommonJobList = Api().post("pdf-reader/upload", payload, config);
        return AllCommonJobList;
    },

    upsertBillingVendorLocation(payload, config) {
        let AllCommonJobList = Api().post("pdf-reader/upsert-location", payload, config);
        return AllCommonJobList;
    },
   
};



// WEBPACK FOOTER //
// ./src/services/PortExpenseService.js